var initializeInlineVideoBlock = function(block){

	// This code loads the IFrame Player API code asynchronously.
	var tag = document.createElement('script');
	
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	
	// Global object to store the youtube video players
	window.ytplayers = {};
	
	// Create the video player after the YouTube api is ready
	window.onYouTubeIframeAPIReady = function () {
	
	    jQuery(document).ready(function($) {
	
	        if ( $('.yt-launch').length > 0 ) {
	
	            $('.yt-launch').each(function(index, el) {
	
	                var thisID = $(this).attr('data-vid'),
	                    thisVid = youtube_parser( $(this).attr('href') ),
	                    thisVidContain = $('#' + thisID + '-contain');
	
	                // Move the video player to the end of the document
	                $('body').append( thisVidContain );
	
	                window.ytplayers[thisID] = createPlayer(thisID, thisVid);
	
	            }); // .each
	
	            $('.yt-launch').click(function(e) {
		            
	                e.preventDefault();
	
	                var thisID = $(this).attr('data-vid'),
	                    thisVid = $('#' + thisID);
	                    
	                
	
	                thisVid.parents('.inline-video-container').addClass('active');
	
	                window.ytplayers[thisID].playVideo();
	
	            }); // .click
	
	            $('.yt-close').click(function(e) {
	                e.preventDefault();
	
	                $(this).parents('.yt-player-contain').removeClass('active');
	
	                stopAllVideos();
	            });
	
	        }
	
	    });
	
	};

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-inline-video').each(function(){
		initializeInlineVideoBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=inline-video', initializeInlineVideoBlock);


function stopAllVideos() {

    jQuery.each(window.ytplayers, function( key, value ) {
        window.ytplayers[key].stopVideo();
    });

} 


//// Function to create a video player
function createPlayer(playerID, videoID) {
    return new YT.Player(playerID, {
        height: '480',
        width: '854',
        videoId: videoID,
        playerVars: { 'modestbranding': 1, 'showinfo': 0, 'rel': 0 }
    });
} //createPlayer()


//// Return the youtube id
function youtube_parser(url){
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
} // youtube_parser()
